'use strict';

import template from './template.html';


export default function() {
	return {
		transclude: true,
		controller: controller,
		controllerAs: '$optionGroup',
		template: template,
	}

	function controller($log) {
		'ngInject';

		var vm = this;

		vm.options = []

		vm.addOption = function(opt) {
			vm.options.push(opt);
		}
	}
}
